import { useDeleteTasks } from 'features/tasks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from 'shared/components/ui/confirm-dialog';

import { DialogProps } from './types';

export const DeleteTasksDialog: React.FC<DialogProps> = ({
  tasks,
  onClose,
}) => {
  const { t } = useTranslation();
  const deleteTasks = useDeleteTasks();

  const onDelete = () => {
    deleteTasks(
      tasks.map((task) => task.id),
      true,
    );
    onClose();
  };

  return (
    <ConfirmDialog
      open
      title={t('tasks.delete-confirm-title', { count: tasks.length })}
      message={t('tasks.delete-confirm-message', { count: tasks.length })}
      onConfirm={onDelete}
      onCancel={onClose}
    />
  );
};
